import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import Menu from '../../Components/AdminComponents/Menu';
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import CircularProgress from '@mui/material/CircularProgress';
import MenuItem from '@mui/material/MenuItem';
import SaveIcon from '@mui/icons-material/Save';
import noimage from '../../assets/no_image.svg';
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import { doc, serverTimestamp, getDoc, updateDoc, addDoc, collection, setDoc } from 'firebase/firestore';
import { db, storage } from '../../firebase';
import { ref, uploadBytesResumable, getDownloadURL } from 'firebase/storage';
import { useNavigate, useParams } from 'react-router-dom';
import Fab from '@mui/material/Fab';
import { Tooltip } from '@mui/material';

const initialState = {
  photo_title: '',
  description: '',
  date: '',
  category: '',
  size: '',
};

function AddEdit({ title, isMobile }) {
  const [data, setData] = useState(initialState);
  const [userData, setUserData] = useState([]);
  const { photo_title, description, category, date, size } = data;
  const [file, setFile] = useState('');
  const [isImg, setIsImg] = useState(true);
  const [progress, setProgress] = useState(null);
  const navigate = useNavigate();
  const { userId } = useParams();
  const { photoId } = useParams();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const docRef = doc(db, 'users', userId, 'photos', photoId);

        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          setData(docSnap.data());
          setIsImg(false);
        } else {
          console.log('No such document!');
        }
      } catch (error) {
        console.log(error);
      }
    };
    fetchData();
    const fetchUser = async () => {
      try {
        const docRef = doc(db, 'users', userId);

        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          setUserData(docSnap.data());
        } else {
          console.log('No such document!');
        }
      } catch (error) {
        console.log(error);
      }
    };
    fetchUser();
  }, [userId, photoId]);

  useEffect(() => {
    const uploadFile = () => {
      const storageRef = ref(storage, file.name);
      const uploadTask = uploadBytesResumable(storageRef, file);

      uploadTask.on(
        'state_changed',
        (snapshot) => {
          const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          console.log('Upload is ' + progress + '% done');
          setProgress(progress);
          switch (snapshot.state) {
            case 'paused':
              console.log('Upload is paused');
              break;
            case 'running':
              console.log('Upload is running');
              break;
            default:
              break;
          }
        },
        (error) => {
          switch (error.code) {
            case 'storage/unauthorized':
              break;
            case 'storage/canceled':
              break;
            default:
              break;

            case 'storage/unknown':
              break;
          }
        },
        () => {
          getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
            setIsImg(false);
            setData((prev) => ({ ...prev, img: downloadURL }));
          });
        }
      );
    };
    file && uploadFile();
  }, [file]);

  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!photoId) {
      try {
        const res = await addDoc(collection(db, 'users', userId, 'photos'), {
          ...data,
          timeStamp: serverTimestamp(),
        });
        await setDoc(doc(db, 'photos', res.id), {
          ...data,
          user: userData.email,
          user_Id: userId,
          timeStamp: serverTimestamp(),
        });

        navigate(-1);
      } catch (error) {
        console.log(error);
      }
    } else {
      try {
        await updateDoc(doc(db, 'users', userId, 'photos', photoId), {
          ...data,
          updatedOn: serverTimestamp(),
        });
        await updateDoc(doc(db, 'photos', photoId), {
          ...data,
          updatedOn: serverTimestamp(),
        });
        navigate(-1);
      } catch (error) {
        console.log(error);
      }
    }
  };

  return (
    <NewStyled>
      <Menu title={title} isMobile={isMobile} />
      <div className="new-container">
        <div className="bottom">
          <div className="left">
            <div className="image-content">
              {isImg ? <img src={noimage} alt="" /> : <img src={file ? URL.createObjectURL(file) : data.img} alt="" />}

              <Tooltip title="Add Photo">
                <Fab
                  color="primary"
                  aria-label="add"
                  sx={{ backgroundColor: '#7199ff', position: 'absolute', bottom: '-8%' }}
                >
                  <label htmlFor="file">
                    <AddPhotoAlternateIcon className="icon" sx={{ fontSize: '32px', color: '#fff' }} />
                  </label>
                </Fab>
              </Tooltip>
            </div>
            <input type="file" id="file" onChange={(e) => setFile(e.target.files[0])} style={{ display: 'none' }} />
            {file && <div className="img-text">{file.name} </div>}
          </div>

          <div className="right">
            <form onSubmit={handleSubmit}>
              <div className="form-input">
                <TextField
                  sx={{ width: '90%' }}
                  id="standard-basic"
                  label="Photo Title"
                  variant="standard"
                  placeholder="Enter Photo Title"
                  name="photo_title"
                  onChange={handleChange}
                  value={photo_title}
                  required
                />
              </div>
              <div className="form-input">
                <TextField
                  sx={{ width: '90%' }}
                  id="standard-basic"
                  label="Description"
                  variant="standard"
                  placeholder="Enter Description"
                  onChange={handleChange}
                  name="description"
                  value={description}
                  required
                />
              </div>
              <div className="form-input">
                <InputLabel id="demo-simple-select-label">Category</InputLabel>
                <Select
                  required
                  sx={{ width: '90%', height: '50%' }}
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={category}
                  onChange={handleChange}
                >
                  <MenuItem value={'Nature'}>Nature</MenuItem>
                  <MenuItem value={'Night'}>Night</MenuItem>
                  <MenuItem value={'Food'}>Food</MenuItem>
                </Select>
              </div>

              <div className="form-input">
                <TextField
                  sx={{ width: '90%' }}
                  disabled
                  id="standard-disabled"
                  label="Date"
                  variant="standard"
                  onChange={handleChange}
                  value={date}
                />
              </div>
              <div className="form-input">
                <TextField
                  sx={{ width: '90%' }}
                  disabled
                  id="standard-disabled"
                  label="Size"
                  variant="standard"
                  onChange={handleChange}
                  value={size}
                />
              </div>

              <div className="button-content">
                <Tooltip title="Save Photo">
                  <Fab color="primary" aria-label="add" sx={{ backgroundColor: '#7199ff' }} type="submit">
                    {progress !== null && progress < 100 ? (
                      <CircularProgress disabled sx={{ color: '#fff' }} />
                    ) : (
                      <SaveIcon />
                    )}
                  </Fab>
                </Tooltip>
              </div>
            </form>
          </div>
        </div>
      </div>
    </NewStyled>
  );
}

const NewStyled = styled.div`
  width: 100%;
  display: flex;
  padding-top: 4rem;
  min-height: 100vh;
  .new-container {
    flex: 6;
    .top,
    .bottom {
      display: flex;
      padding: 10px;
      margin: 20px;
      gap: 50px;

      @media screen and (max-width: 956px) {
        padding-top: 2rem;
        display: block;
      }

      h1 {
        color: var(--accent-blue);
        font-size: 20px;
      }

      .left {
        flex: 1;
        text-align: center;
        display: flex;

        flex-direction: column;
        .image-content {
          position: relative;
          display: flex;
          justify-content: center;
        }
        label {
          display: flex;
          cursor: pointer;
        }

        .img-text {
          padding-top: 2rem;
        }

        img {
          width: 300px;
          height: 300px;
          border-radius: 5px;
          object-fit: cover;
        }
      }

      .right {
        color: black;

        form {
          display: flex;
          flex-wrap: wrap;
          gap: 20px;
          justify-content: space-around;
          flex-direction: row;
          justify-content: flex-start;
          @media screen and (max-width: 956px) {
            padding-top: 2rem;
            display: block;
          }

          .form-input {
            width: 100%;
            @media screen and (max-width: 956px) {
              width: 100%;
              padding-top: 2rem;
            }

            label {
              display: flex;
              align-items: center;
              gap: 10px;

              .icon {
                cursor: pointer;
              }
            }
          }
          .button-content {
            width: 90%;
            display: flex;
            justify-content: center;
            @media screen and (max-width: 956px) {
              width: 100%;
              padding: 2rem 0;
              display: flex;
              align-items: center;
              text-align: center;
              justify-content: center;
            }
          }
        }
      }
    }
  }
`;

export default AddEdit;
